var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44051 4.39128C4.56786 4.02926 4.81922 3.724 5.15007 3.52956C5.48092 3.33511 5.86992 3.26403 6.24815 3.32891C6.62639 3.39379 6.96946 3.59044 7.2166 3.88402C7.46374 4.17761 7.599 4.54918 7.59843 4.93294C7.59843 6.01628 5.97343 6.55794 5.97343 6.55794M6.01676 8.72461H6.02218M11.4334 6.01628C11.4334 9.00782 9.00831 11.4329 6.01676 11.4329C3.02522 11.4329 0.600098 9.00782 0.600098 6.01628C0.600098 3.02473 3.02522 0.599609 6.01676 0.599609C9.00831 0.599609 11.4334 3.02473 11.4334 6.01628Z",
    stroke: "#848698",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question_icon.b92809003ad597579a87a1e76ef97a50.svg";
export { ForwardRef as ReactComponent };